module.exports = __webpack_public_path__ + "img/life-empty.52c69174.svg";